export default {
	title: "Goals",
	newGoalButton: "New Goal",
};
